module.exports = __webpack_public_path__ + "img/banner_tasantea.bbb4ba00.jpg";